import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, search } = useLocation();
    const prevPathnameRef = useRef(pathname);
    const prevCategoryRef = useRef(null);
    const prevCollectionRef = useRef(null);
    const prevKeywordRef = useRef(null);

    useEffect(() => {
        const params = new URLSearchParams(search);
        const category = params.get('category');
        const collection = params.get('collection');
        const keyword = params.get('keyword');

        const isPathnameChanged = prevPathnameRef.current !== pathname;
        const isCategoryChanged = prevCategoryRef.current !== category;
        const isCollectionChanged = prevCollectionRef.current !== collection;
        const isKeywordChanged = prevKeywordRef.current !== keyword;

        if (isPathnameChanged || isCategoryChanged || isCollectionChanged || isKeywordChanged) {
            window.scrollTo(0, 0);
        }

        // Update refs
        prevPathnameRef.current = pathname;
        prevCategoryRef.current = category;
        prevCollectionRef.current = collection;
        prevKeywordRef.current = keyword;
    }, [pathname, search]);

    return null;
};

export default ScrollToTop;
